class CountdownTimer extends HTMLElement {
    constructor() {
        super();
        this.timer = null;
        this.endDate = new Date(this.getAttribute('data-date')).getTime();
        this.elements = {
            days: this.querySelector('[data-days]'),
            hours: this.querySelector('[data-hours]'),
            minutes: this.querySelector('[data-minutes]'),
            seconds: this.querySelector('[data-seconds]')
        };

        // Circular progress rings (optional)
        this.rings = {
            days: this.querySelector('[data-ring="days"]'),
            hours: this.querySelector('[data-ring="hours"]'),
            minutes: this.querySelector('[data-ring="minutes"]'),
            seconds: this.querySelector('[data-ring="seconds"]')
        };

        this.circumference = 2 * Math.PI * 45; // r=45
    }

    connectedCallback() {
        if (isNaN(this.endDate)) return;

        // Initial update
        this.update();

        // Start timer
        this.timer = setInterval(this.update.bind(this), 1000);
    }

    disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
    }

    update() {
        const now = new Date().getTime();
        const distance = this.endDate - now;

        if (distance < 0) {
            clearInterval(this.timer);
            this.innerHTML = '<div class="center h3">Offer Expired</div>';
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        requestAnimationFrame(() => {
            this.updateText(days, hours, minutes, seconds);
            if (this.hasRings()) {
                this.updateRings(days, hours, minutes, seconds);
            }
        });
    }

    updateText(days, hours, minutes, seconds) {
        if (this.elements.days) this.elements.days.textContent = this.format(days);
        if (this.elements.hours) this.elements.hours.textContent = this.format(hours);
        if (this.elements.minutes) this.elements.minutes.textContent = this.format(minutes);
        if (this.elements.seconds) this.elements.seconds.textContent = this.format(seconds);
    }

    updateRings(days, hours, minutes, seconds) {
        // Max values for rings: 
        // Hours: 24, Minutes: 60, Seconds: 60. Days: Cap at 30 for visual scale or 100? Let's say 30.
        this.setRingOffset(this.rings.days, days, 30);
        this.setRingOffset(this.rings.hours, hours, 24);
        this.setRingOffset(this.rings.minutes, minutes, 60);
        this.setRingOffset(this.rings.seconds, seconds, 60);
    }

    setRingOffset(element, value, maxValue) {
        if (!element) return;

        // Ensure value doesn't exceed visual max
        const visualValue = value > maxValue ? maxValue : value;

        // Calculate offset. 
        // Full ring = 0 offset. Empty ring = circumference.
        // We want ring to decrease as time decreases.
        // So value=Max -> offset=0. value=0 -> offset=circumference.
        // Wait, normally countdowns "unfill".
        // If 60 seconds left (full), we want full circle? Or empty?
        // Usually, 60s = Full circle. 0s = Empty circle.
        // dashoffset = circumference - (value / maxValue) * circumference

        const offset = this.circumference - (visualValue / maxValue) * this.circumference;
        element.style.strokeDashoffset = offset;
    }

    hasRings() {
        return !!this.rings.seconds;
    }

    format(time) {
        return time < 10 ? `0${time}` : time;
    }
}

customElements.define('countdown-timer', CountdownTimer);
